export const getNotifications = (state) => state.notifications
export const getNotificationCount = (state) => state.notification_count || 0
export const currentPage = (state) => state.notification_current_page || 0
export const lastPage = (state) => state.notification_last_page || 0

